import React, { FC, useState, useEffect } from 'react'
import { IonModal, IonContent, IonFooter, IonHeader } from '@ionic/react'
import { ProductImage, UseTextArea } from '@cps'
import { cartMobx, restaurantConfig } from 'mobx/mall'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import './index.scss'

interface IProps {
  reject?: any;
  resolve?: any;
}

const CatProductRemark: FC<IProps> = (props) => {
  // 后付费已下单不能再修改整单备注
  // && !!orderMobx.viewOrder.nono
  const cannotRemarkOrder = !!cartMobx.ordersId
  const { reject, resolve } = props
  const [_remarkStatus, setRemarkStatus] = useState(cannotRemarkOrder)
  const [_remarkInfos, setRemarkInfos] = useState({ order: '' } as any)
  const optionModify = (cartItem: IViewMallCartItem) => {
    return null
  }
  useEffect(() => {
    if (cartMobx.cartProductHasReamrkStatus) {
      setRemarkStatus(true)
    }
    let obj: Record<string, string> = {
      order: toJS(cartMobx.info.remark || '')
    }
    toJS(cartMobx.cartItems).forEach(carteItem => {
      obj[carteItem.pk] = carteItem.remark || ''
    })
    setRemarkInfos(obj)
  }, [])
  const handleChange = (value: string, key: string) => {
    if (_remarkInfos[key] !== undefined) {
      setRemarkInfos({
        ..._remarkInfos,
        [key]: value
      })
    }
  }
  const saveReamrk = () => {
    if (cartMobx.info.remark !== (_remarkInfos.order || '')) {
      cartMobx.setRemark(_remarkInfos.order || '')
    }
    if (_remarkStatus) {
      cartMobx.setCartProductRemark(_remarkInfos)
    }
    resolve()
  }
  return (
    <IonModal
      isOpen
      cssClass={`mall-remark-modal ${_remarkStatus ? 'remark-product-modal' : ''}`}
      swipeToClose
      onDidDismiss={() => reject()}
    >
      <IonHeader>
        <div className='remark-title'>
          <span>{i18n.t('cart.special')}</span>
          <i className='iconfont icon-close' onClick={() => reject()}></i>
        </div>
      </IonHeader>
      <IonContent className='remark-content' scrollEvents>
        <div className='mall-remark-modal-content'>
          {
            !cannotRemarkOrder && (
              <div className='remark-all-remark'>
                <span className='remark-name'>{i18n.t('cart.allproduct')}</span>
                <UseTextArea
                  maxLength={128}
                  value={_remarkInfos.order}
                  showLength={118}
                  autohHeight
                  placeholder={i18n.t('cart.remartplacechoder')}
                  onChange={(e: any) => handleChange(e, 'order')}
                />
              </div>
            )
          }
          {
            !cannotRemarkOrder && (
              <div className={`remark-spread ${_remarkInfos.order?.length >= 118 ? 'showlen' : ''}`}>
                {i18n.t('cart.canyouremark')}
                <span onClick={() => setRemarkStatus(!_remarkStatus)}>{!_remarkStatus ? i18n.t('cart.out') : i18n.t('cart.up')}</span>
              </div>
            )
          }
          {_remarkStatus ? (
            <div className='remark-product-warp'>
              {cartMobx.viewCartItems.map(cartItem => {
                return (
                  <div className='remark-product-detail' key={cartItem.pk}>
                    <div className='remark-product-info'>
                      <ProductImage type='mall' color={!cartItem.pic && restaurantConfig.displayMode === 'waterfall' ? cartItem.productNo : ''} imgSrc={cartItem.pic} width={48} />
                      <div className='product-info'>
                        <strong>{cartItem.name}</strong>
                        {optionModify(cartItem)}
                      </div>
                    </div>
                    <UseTextArea
                      maxLength={128}
                      value={_remarkInfos[cartItem.pk] || ''}
                      showLength={118}
                      autohHeight
                      placeholder={i18n.t('cart.remartplacechoder')}
                      onChange={(e: any) => handleChange(e, cartItem.pk)}
                    />
                  </div>
                )
              })}
            </div>
          ) : null}
        </div>
      </IonContent>
      <IonFooter className='remark-footer'>
        <div className='remark-button' onClick={saveReamrk}>{i18n.t('common.save')}</div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(CatProductRemark)
